import axiosClient from "@/libs/axiosClient";

export const getUserData = () => {
    return axiosClient.get(`/user`);
};

export const resendOtpMail = (data) => {
    return axiosClient.post(`/table/rcm-users/update/resendotpmail`, data);
};

export const resetPwdMail = (data) => {
    return axiosClient.post(`/table/rcm-users/update/resetpassword`, data);
};

export const removeFromGroup = (data) => {
    return axiosClient.post(`/table/rcm-users/update/removefromgroup`, data);
};

export const _login = (data) => {
    return axiosClient.post(`/user/login`, data);
};

export const _logout = (data) => {
    return axiosClient.get(`/user/logout`);
};

export const getActiveSessions = () => {
    return axiosClient.get(`/user/get-active-sessions`);
};

export const destroyActiveSession = (data) => {
    return axiosClient.post(`/user/destroy-active-session`, data);
};

export const resetPassword = (data) => {
    return axiosClient.post(`/user/resetpassword`, data);
};

export const setUserAvatar = (data) => {
    return axiosClient.post(`/user/set-user-avatar`, data);
};

export const changeUserRole = ({ userName, groupName, roleName }) => {
    return axiosClient.post(`/user/change-user-role`, { userName, groupName, roleName });
};

export const setUserLang = (data) => {
    return axiosClient.post(`/user/set-user-lang`, data);
};

export const generateInvitationLink = ({ username, groupName, roleName }) => {
    return axiosClient.post(`/table/rcm-users/update/generate-invitation-link`, { username, groupName, roleName });
};

export const validateInvitationToken = ({ token, taskNo }) => {
    return axiosClient.get(`/user/validate-invitation-token?token=${token}&taskNo=${taskNo}`);
};

export const signupByInvite = ({ token, taskNo, password }) => {
    return axiosClient.post(`/user/signup-by-invite?token=${token}&taskNo=${taskNo}`, { password });
};

// export const addUserToGroup = ({ username, groupName, roleName }) => {
//     return axiosClient.post(`/table/rcm-users/update/add-user-to-group`, { username, groupName, roleName });
// };

export const resetUserData = (data) => {
    return axiosClient.post(`/user/resetuserdata`, data);
};

export const setAllowIp = (data) => {
    return axiosClient.post(`/user/set-allow-ip-list`, data);
};

export const sendUserLoginValidationMail = (data) => {
    return axiosClient.post(`/user/senduserloginvalidation`, data);
};

export const verifyUserLoginValidationMail = (data) => {
    return axiosClient.post(`/user/add-userinfo-by-mail`, data);
};

export const _deleteDevice = (data) => {
    return axiosClient.delete(`/user/delete-deviceinfo`, { data });
};

export const validateResetpasswordToken = ({ token }) => {
    return axiosClient.get(`/user/validate-resetpassword-token?token=${token}`);
};

export const validateResetPassword = ({ token, data }) => {
    return axiosClient.post(`/user/validate-resetpassword-token?token=${token}`, data);
};

export const validateResetOTPToken = ({ token }) => {
    return axiosClient.get(`/user/validate-resetOTP-token?token=${token}`);
};

export const getResetMailToken = () => {
    return axiosClient.get(`/user/validate-mail-token`);
};

export const validateResetMailToken = ({ data }) => {
    return axiosClient.post(`/user/validate-mail-token`, data);
};

export const resetMail = ({ data }) => {
    return axiosClient.post(`/user/validate-mail-token/resetMail`, data);
};



// WEBPACK FOOTER //
// ./src/api/user.js